module.exports = __webpack_public_path__ + "static/media/Chicken5.5c6607d6.png";